module.exports = __webpack_public_path__ + "static/media/Limber Musculoskeletal Header Photo.e2253a49.png";